
import BlankLayout from "@/layouts/BlankLayout.vue";
import PlatformLayout from "@/layouts/PlatformLayout.vue";


const routes = [

  {
    path:'/',
    component:BlankLayout,
    children:[
      {
        path: '/',
        name:'login',
        component:() => import('@/pages/login/index.vue'),
      },

    ]
  },
]
export default routes